export default __webpack_public_path__ + "static/main_seo_image-4e8c6efa0de591e9b6cd4ed6905c946a.jpg";